export default __webpack_public_path__ + "static/media/screen6.4ba9998c.png";